export default "__VITE_ASSET__DNbfw5Uf__"